import apiClient from '../base/apiClient';

export const authApi = {
  login: async ({ username, password }: { username: string; password: string }) => {
    const response = await apiClient.post('/Administration/Login', { username, password });
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    if (response.data.sessionToken == null) throw new Error('Session token not found');
    localStorage.setItem('sessionToken', response.data.sessionToken);
    return response.data;
  },

  logout: async () => {
    const sessionToken = localStorage.getItem('sessionToken');
    if (!sessionToken) return Promise.resolve();
    const response = await apiClient.get('/Administration/Logout');
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    localStorage.removeItem('sessionToken');
    return Promise.resolve();
  },

  checkAuth: async () => {
    const sessionToken = localStorage.getItem('sessionToken');
    if (!sessionToken) throw new Error('No session token found');
    const response = await apiClient.get('/Administration/Details');
    if (response.data.errorMessage) {
      localStorage.removeItem('sessionToken');
      throw new Error(response.data.errorMessage);
    }
    if (response.data.error) {
      localStorage.removeItem('sessionToken');
      throw new Error(response.data.error);
    }
    const currentAdminId = response.data.administratorId || response.data.id;
    localStorage.setItem('currentAdminId', currentAdminId.toString());
    return Promise.resolve();
  },
};